@if(!orderNotFound){
@if(activeModal){
<button type="button" class="ad-modal-close btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
}
<div class="ad-page-body">
    <!-- First-load :has(> .ad-cx-loader). -->
    @if(isOrderLoading){
    <div class="ad-cx-loader" [class.is-leaving]="isOrderLoaderLeaving" role="status" aria-live="polite">
        <div class="ad-cx-loader__halo" aria-hidden="true"></div>
        <span class="ad-agentic-ai-menu is-live ad-cx-loader__mark" aria-hidden="true">
            <img class="ad-od-globe-logo" src="assets/images/globe-ai.png" alt="">
            <img class="ad-cx-loader__brand" src="assets/images/favicon.png" alt="">
        </span>
        <p class="ad-cx-loader__title">Preparing order details</p>
        <p class="ad-cx-loader__caption">
            <span class="ad-cx-live__think" aria-hidden="true">
                <span></span><span></span><span></span>
            </span>
            <span>Fetching status, route and activity</span>
        </p>
        <div class="ad-cx-loader__skeleton" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    }


    <div class="ad-od" [ngClass]="'status-' + orderData?.order_status_id"
        [class.ad-od--has-activity]="showControlxPanel" [class.ad-od-status-flash]="showStatusFlash">
        <div class="ad-od-col ad-od-col--map">
            <div class="ad-od-map" [class.is-expanded]="isMapExpanded">
                <div id="orderDetailMap" class="ad-od-map__canvas"></div>
                @if(playCountdown !== null){
                <div class="ad-od-map__countdown" role="status" aria-live="assertive">
                    @for(n of [playCountdown]; track n){
                    <span class="ad-od-map__count">{{ n }}</span>
                    }
                </div>
                }

                <div class="ad-od-map__tools">
                    <div class="ad-od-map__toolrow">
                        @if(riderLocation){
                        <button type="button" class="ad-od-map__chip ad-od-map__chip--icon" (click)="resetMapView()"
                            aria-label="Reset map view" ngbTooltip="Reset view" container="body" placement="bottom">
                            <i class="icofont icofont-refresh"></i>
                        </button>
                        }
                        <button type="button" class="ad-od-map__chip ad-od-map__chip--icon" (click)="toggleMapExpand()"
                            [attr.aria-pressed]="isMapExpanded"
                            [attr.aria-label]="isMapExpanded ? 'Exit full screen map' : 'Expand map to full screen'"
                            [ngbTooltip]="isMapExpanded ? 'Exit full screen (Esc)' : 'Expand map'" container="body"
                            placement="bottom">
                            @if(isMapExpanded){
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M18 7H21V9H16V4H18V7ZM8 9H3V7H6V4H8V9ZM18 17V20H16V15H21V17H18ZM8 15V20H6V17H3V15H8Z">
                                </path>
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M20 3H22V9H20V5H16V3H20ZM4 3H8V5H4V9H2V3H4ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z">
                                </path>
                            </svg>
                            }
                        </button>
                    </div>
                    @if(riderLocationLoading){
                    <div class="ad-od-map__chip ad-od-map__chip--status">
                        <i class="icofont icofont-spinner-alt-4"></i> Locating rider…
                    </div>
                    } @else if(riderLocationError){
                    <div class="ad-od-map__chip ad-od-map__chip--error">
                        <i class="icofont icofont-warning-alt"></i> Rider location unavailable
                    </div>
                    }
                </div>
                @if(riderPlaybackReady){
                <div class="ad-od-player">
                    <button type="button" class="ad-od-player__btn ad-od-player__btn--play"
                        (click)="onPlayButtonClick()"
                        [attr.aria-label]="playCountdown !== null ? 'Cancel countdown' : (isRiderPlaying ? 'Pause rider playback' : 'Play rider playback')">
                        <i class="icofont"
                            [ngClass]="isRiderPlaying || playCountdown !== null ? 'icofont-ui-pause' : 'icofont-ui-play'"></i>
                    </button>
                    <button type="button" class="ad-od-player__btn" (click)="recenterOnRider()"
                        aria-label="Recenter on rider">
                        <i class="icofont icofont-location-arrow"></i>
                    </button>

                    <div class="ad-od-player__scrubber">
                        <input type="range" min="0" max="100" step="0.1" [value]="riderPlaybackProgress"
                            class="ad-od-player__slider" [style.--rider-progress.%]="riderPlaybackProgress"
                            (input)="onPlaybackSeek($event)" aria-label="Playback progress" />
                        <div class="ad-od-player__times">
                            <span>{{ riderPlaybackStartLabel }}</span>
                            <span class="ad-od-player__now">{{ riderPlaybackCurrentLabel }}</span>
                            @if(riderPlaybackIsIdle){
                            <span class="ad-rca-playback-idle"><span class="ad-rca-playback-idle__dot"></span>
                                IDLE</span>
                            }
                            <span>{{ riderPlaybackEndLabel }}</span>
                        </div>
                    </div>

                    <div class="ad-od-player__menu">
                        <button type="button" class="ad-od-player__btn" (click)="toggleRiderPlaybackSpeedMenu()"
                            aria-label="Playback speed" [attr.aria-expanded]="riderPlaybackSpeedMenuOpen">
                            <i class="icofont icofont-options"></i>
                        </button>
                        @if(riderPlaybackSpeedMenuOpen){
                        <div class="ad-od-player__list">
                            @for(speed of [0.25, 0.5, 1, 2, 4]; track speed) {
                            <button type="button" class="ad-rca-speed-option"
                                [class.active]="riderPlaybackSpeed === speed" (click)="setRiderPlaybackSpeed(speed)">{{
                                speed }}x</button>
                            }
                        </div>
                        }
                    </div>
                </div>
                }
                @if(lastStatus){
                <div class="ad-od-map__group" [ngClass]="'status-' + orderData?.order_status_id">
                    <div class="ad-od-map__badge">
                        <img src={{lastStatus.iconUrl}} alt="status-icon"
                            (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-block">
                                <h4 class="mb-0 ad-od-status-type" [class.is-typing]="isStatusTyping">{{ statusTyped }}
                                </h4>
                                <p class="mb-0"><small>{{ lastStatus?.riderName || '' }}</small></p>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
            <!-- /map -->

            <div class="ad-od-card ad-od-card--fixed" [ngClass]="'status-' + orderData?.order_status_id">
                <div class="ad-od-map__stats">
                    <div class="ad-od-map__stat">
                        <p class="mb-0"><small>Total Distance</small></p>
                        <h4 class="mb-0">{{ lastStatus.distanceRemaining }}</h4>
                    </div>
                    <div class="ad-od-map__stat ad-od-map__stat--end">
                        <p class="mb-0"><small>{{ lastStatus?.time || '' }} <span class="ad-od-map__stat-sep">|</span>
                                {{ lastStatus?.date || '' }}</small></p>
                        <h4 class="mb-0">{{ lastStatus.timeRemaining }}</h4>
                    </div>
                </div>

                <div class="ad-od-card__body">
                    <div class="ad-od-fields ad-od-fields--row ad-od-fields--ids">
                        <div class="ad-od-field" placement="top"
                            ngbTooltip="The order ID created by our system for identifying this order."
                            tooltipClass="ad-od-tooltip" container="body">
                            <span>Order ID</span>
                            <span class="ad-od-value">
                                <span class="ad-text-limit" [title]="orderData?.order_id">{{
                                    commonLogics.truncateStart(orderData?.order_id) }}</span>
                                <button class="ad-od-iconbtn"
                                    (click)="copyToClipboard(orderData?.order_id || 'RTG3647126')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        @if(orderData?.partner_order_id){
                        <span class="ad-od-fields__sep" aria-hidden="true"></span>
                        <div class="ad-od-field" placement="top" ngbTooltip="Order ID received from the partner."
                            tooltipClass="ad-od-tooltip" container="body">
                            <span>Partner Order ID</span>
                            <span class="ad-od-value">
                                <span class="ad-text-limit" [title]="orderData?.partner_order_id"><span
                                        class="ad-id-head">{{commonLogics.truncateMiddleParts(orderData?.partner_order_id).head}}</span><span
                                        class="ad-id-tail">{{commonLogics.truncateMiddleParts(orderData?.partner_order_id).tail}}</span></span>
                                <button type="button" class="ad-od-iconbtn" aria-label="Copy Partner Order ID"
                                    (click)="copyToClipboard(orderData?.partner_order_id, 'Partner Order ID')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        }
                        @if(orderData?.partner_reference_id){
                        <span class="ad-od-fields__sep" aria-hidden="true"></span>
                        <div class="ad-od-field" placement="top"
                            ngbTooltip="A secondary partner reference ID associated with this order."
                            tooltipClass="ad-od-tooltip" container="body">
                            <span>Order Referral ID</span>
                            <span class="ad-od-value">
                                <span class="ad-text-limit" [title]="orderData?.partner_reference_id"><span
                                        class="ad-id-head">{{commonLogics.truncateMiddleParts(orderData?.partner_reference_id).head}}</span><span
                                        class="ad-id-tail">{{commonLogics.truncateMiddleParts(orderData?.partner_reference_id).tail}}</span></span>
                                <button type="button" class="ad-od-iconbtn" aria-label="Copy Order Referral ID"
                                    (click)="copyToClipboard(orderData?.partner_reference_id, 'Order Referral ID')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        }
                        @if(orderData?.order_uuid){
                        <span class="ad-od-fields__sep" aria-hidden="true"></span>
                        <div class="ad-od-field" placement="top"
                            ngbTooltip="A unique external Order UUID generated from our internal Order ID for customers and 3PL partners."
                            tooltipClass="ad-od-tooltip" container="body">
                            <span>Order UUID</span>
                            <span class="ad-od-value">
                                <span class="ad-text-limit" [title]="orderData?.order_uuid"><span
                                        class="ad-id-head">{{commonLogics.truncateMiddleParts(orderData?.order_uuid).head}}</span><span
                                        class="ad-id-tail">{{commonLogics.truncateMiddleParts(orderData?.order_uuid).tail}}</span></span>
                                <button type="button" class="ad-od-iconbtn" aria-label="Copy Order UUID"
                                    (click)="copyToClipboard(orderData?.order_uuid, 'Order UUID')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        }
                        @if(orderData?.partner_primary_id){
                        <span class="ad-od-fields__sep" aria-hidden="true"></span>
                        <div class="ad-od-field" placement="top"
                            ngbTooltip="A unique primary ID representing the partner for internal purposes."
                            tooltipClass="ad-od-tooltip" container="body">
                            <span>Partner Primary ID</span>
                            <span class="ad-od-value">
                                <span class="ad-text-limit" [title]="orderData?.partner_primary_id">{{
                                    commonLogics.truncateStart(orderData?.partner_primary_id) }}</span>
                                <button class="ad-od-iconbtn" (click)="copyToClipboard(orderData?.partner_primary_id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </span>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <!-- /order identifiers -->

            <!-- 3PL-panel row sentence: icon + "<Provider> <text>". Data from
                 getAllocationNote(); tone classes override the row status colour. -->
            <ng-template #allocNote let-n>
                <p class="mb-0 ad-od-tl-note" [ngClass]="n.tone ? 'is-' + n.tone : ''">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        @switch (n.icon) {
                        @case ('assigned') { <path d="M20 6 9 17l-5-5"></path> }
                        @case ('delivered') { <circle cx="12" cy="12" r="10"></circle>
                        <path d="m8 12 3 3 5-6"></path> }
                        @case ('cancelled') { <circle cx="12" cy="12" r="10"></circle>
                        <path d="m15 9-6 6M9 9l6 6"></path> }
                        @case ('not-serviceable') {
                        <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 11.9-5"></path>
                        <path d="M18.6 8.6A7 7 0 0 1 19 9.5c0 4-3.6 8-5.5 9.9"></path>
                        <path d="m3 3 18 18"></path>
                        }
                        @case ('no-rider') {
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M2 21v-1a6 6 0 0 1 10.3-4.2"></path>
                        <path d="m17 14 5 5M22 14l-5 5"></path>
                        }
                        @case ('pending') { <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 6v6l4 2"></path> }
                        @case ('arrived') { <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                        <circle cx="12" cy="10" r="3"></circle> }
                        @case ('picked-up') {
                        <path d="M21 8 12 3 3 8v8l9 5 9-5Z"></path>
                        <path d="m3 8 9 5 9-5M12 13v8"></path>
                        }
                        @case ('transit') {
                        <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"></path>
                        <circle cx="5.5" cy="18.5" r="2.5"></circle>
                        <circle cx="18.5" cy="18.5" r="2.5"></circle>
                        }
                        @case ('return') { <path d="M9 14 4 9l5-5"></path>
                        <path d="M4 9h11a5 5 0 0 1 0 10h-3"></path> }
                        @default { <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 16v-4M12 8h.01"></path> }
                        }
                    </svg>
                    <span>@if(n.name){<strong>{{ n.name }}</strong>{{ n.raw ? ': ' : ' ' }}}{{ n.text }}</span>
                </p>
            </ng-template>

            <!-- Order's current status, shown at the right of the 3PL Allocation
                 header (sheet + card). -->
            <ng-template #threePlStatus>
                @if(orderData?.order_status_id){
                <span class="ad-3pl-status" [ngClass]="'status-' + orderData?.order_status_id"
                    ngbTooltip="Current status" placement="bottom" container="body">
                    <span class="ad-3pl-status__dot" aria-hidden="true"></span>
                    <span class="ad-3pl-status__text">{{ constant.OrderStatusName[orderData?.order_status_id === 8 ? 23
                        : orderData?.order_status_id] }}</span>
                </span>
                }
            </ng-template>

            <ng-template #threePlTimeline>
                <div class="ad-od-timeline">

                    <!-- Timeline Entries: every row of the RCA response (orderFlow +
                         integratedresponse), newest-first. -->
                    @for(allocation of thirdPartyAllocation; track allocation.__rowKey){
                    @if(allocation?.ctd_dt){
                    <div class="ad-od-tl-item ad-od-tl-item--alloc"
                        [ngClass]="'status-' + allocation?.order_status_id">
                        <!-- Connector -->
                        <div class="ad-od-tl-rail"></div>
                        <!-- Entry Content -->
                        <div class="ad-od-tl-row">
                            <div class="ad-od-tl-main">
                                <div class="ad-od-tl-marker ad-od-tl-marker--logo" [ngClass]="'rapido'">
                                    <img [src]="allocation.DeliveryPartner.icon_url"
                                        [alt]="allocation.DeliveryPartner.full_name"
                                        (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                                </div>
                                <div class="ad-od-tl-body">
                                    <p class="mb-0 ad-od-tl-head">
                                        <span class="d-flex gap-1 align-items-center">
                                            <span class="ad-od-tl-title">{{
                                                allocation?.DeliveryPartner?.full_name }}</span>
                                        </span>
                                    </p>
                                    @if(getAllocationNote(allocation, true); as note){
                                    <ng-container
                                        *ngTemplateOutlet="allocNote; context: { $implicit: note }"></ng-container>
                                    }
                                    @if(allocation?.partner_uniq_order_id){
                                    <div class="ad-od-tl-ref">
                                        <p class="ad-text-limit mb-0">{{
                                            allocation?.partner_uniq_order_id
                                            }}</p>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(allocation?.partner_uniq_order_id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2">
                                                </rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </div>
                                    }
                                    <p class="mb-0 ad-timeline-duration">{{ allocation?.timeDifference }}
                                    </p>
                                </div>
                            </div>
                            <div class="ad-od-tl-aside">
                                <p class="mb-0">{{ orderDateFormat(allocation?.date_time,
                                    constant.timeFromatHtmlWithSec) }}</p>
                                <p class="mb-0"><small>{{
                                        orderDateFormat(allocation?.date_time,
                                        constant?.dateFormat) }}</small></p>
                            </div>
                        </div>
                    </div>
                    } @else {
                    <div class="ad-od-tl-item ad-od-tl-item--alloc"
                        [ngClass]="'status-' + allocation?.order_status_id">
                        <!-- Connector -->
                        <div class="ad-od-tl-rail"></div>
                        <!-- Entry Content -->
                        <div class="ad-od-tl-row">
                            <div class="ad-od-tl-main">
                                <div class="ad-od-tl-marker ad-od-tl-marker--logo" [ngClass]="'rapido'">
                                    @if(allocation?.DeliveryStaff){
                                    <img src="assets/images/avatar/3pl/ek-bharat.png" alt="Rider Profile">
                                    } @else if(allocation?.DeliveryPartner){
                                    <img src={{allocation.DeliveryPartner.icon_url}} alt="Rider Profile"
                                        (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                                    }
                                </div>
                                <div class="ad-od-tl-body">
                                    <p class="mb-0 ad-od-tl-head">
                                        <span class="ad-od-tl-title ad-od-tl-title--status">{{
                                            constant.OrderStatusName[allocation?.order_status_id === 8 ? 23
                                            :
                                            allocation?.order_status_id] }}</span>
                                    </p>
                                    @if(getAllocationNote(allocation, false); as note){
                                    <ng-container
                                        *ngTemplateOutlet="allocNote; context: { $implicit: note }"></ng-container>
                                    } @else if(getProviderName(allocation)){
                                    <span class="ad-od-tl-sub">{{ getProviderName(allocation) }}</span>
                                    }
                                    @if(allocation?.partner_uniq_order_id){
                                    <div class="ad-od-tl-ref">
                                        <p class="ad-text-limit mb-0">{{
                                            allocation?.partner_uniq_order_id
                                            }}</p>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(allocation?.partner_uniq_order_id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2">
                                                </rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </div>
                                    }
                                    <p class="mb-0 ad-timeline-duration">{{ allocation?.timeDifference }}
                                    </p>
                                </div>
                            </div>
                            <div class="ad-od-tl-aside">
                                <p class="mb-0">{{ orderDateFormat(allocation?.date_time,
                                    constant.timeFromatHtmlWithSec) }}</p>
                                <p class="mb-0"><small>{{
                                        orderDateFormat(allocation?.date_time,
                                        constant?.dateFormat) }}</small></p>
                            </div>
                        </div>
                    </div>
                    }
                    }
                </div>
            </ng-template>

            <!-- 3PL Allocation Card  -->
            @if(has3plAllocation && isBeforeAssigned){
            <div class="ad-od-card">
                <div class="ad-od-card__head">
                    <div class="ad-od-card__icon is-accent">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                            fill="currentColor">
                            <path
                                d="M9 17C9 16.4474 8.77709 15.949 8.41406 15.5859C8.05104 15.2229 7.55256 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17ZM19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17ZM9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7ZM19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 7.55256 15.2229 8.05104 15.5859 8.41406C15.949 8.77709 16.4474 9 17 9C18.1046 9 19 8.10457 19 7ZM21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7ZM21 7C21 9.20914 19.2091 11 17 11C16.2584 11 15.5634 10.7972 14.9678 10.4453L10.4453 14.9678C10.7972 15.5634 11 16.2584 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C7.74116 13 8.43593 13.2022 9.03125 13.5537L13.5537 9.03125C13.2022 8.43593 13 7.74116 13 7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7Z">
                            </path>
                        </svg>
                    </div>
                    <h4 class="ad-od-card__title">3PL Allocation</h4>
                    <ng-container *ngTemplateOutlet="threePlStatus"></ng-container>
                </div>

                <div class="ad-od-card__body">
                    <ng-container *ngTemplateOutlet="threePlTimeline"></ng-container>
                </div>
            </div>
            }

            <!-- Order journey — same timeline pattern as 3PL Allocation -->
            <!-- ad-cx-loader-host is _controlx.scss's opt-in hook: it gives this
                 card the positioning context the cover below needs, and only
                 while a cover is actually mounted (:has).
                 Hidden only while the order is Pending and has never been
                 assigned -- see isPendingNeverAssigned. -->
            @if(!isPendingNeverAssigned){
            <div class="ad-od-card ad-cx-loader-host">
                @if(isStatusUpdating){
                <div class="ad-cx-loader ad-cx-loader--compact" [class.is-leaving]="isStatusLoaderLeaving" role="status"
                    aria-live="polite">
                    <span class="ad-agentic-ai-menu is-live ad-cx-loader__mark" aria-hidden="true">
                        <img class="ad-od-globe-logo" src="assets/images/globe-ai.png" alt="">
                        <img class="ad-cx-loader__brand" src="assets/images/favicon.png" alt="">
                    </span>
                    <p class="ad-cx-loader__title">Updating order status</p>
                    <p class="ad-cx-loader__caption">
                        <span class="ad-cx-live__think"
                            aria-hidden="true"><span></span><span></span><span></span></span>
                        <span>{{ constant.OrderStatusName[orderData?.order_status_id === 8 ? 23 :
                            orderData?.order_status_id] }}</span>
                    </p>
                </div>
                }
                <div class="ad-od-card__head">
                    <div class="ad-od-card__icon is-accent">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                            fill="currentColor">
                            <path
                                d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z">
                            </path>
                        </svg>
                    </div>
                    <div class="d-flex align-items-center justify-content-start gap-2">
                        <h4 class="ad-od-card__title">Order Status</h4>
                        <div class="ad-order-status ad-od-card__aside"
                            [ngClass]="'status-' + orderData?.order_status_id">
                            <span></span>
                            <p class="mb-0">
                                {{constant.OrderStatusName[orderData?.order_status_id === 8 ? 23 :
                                orderData?.order_status_id]}}</p>
                        </div>
                    </div>


                    @if(has3plAllocation && !isBeforeAssigned){
                    <button type="button" class="ad-od-btn ad-od-btn--pill ad-od-btn--glow ad-od-card__aside"
                        (click)="open3plSheet()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"
                            fill="currentColor">
                            <path
                                d="M9 17C9 16.4474 8.77709 15.949 8.41406 15.5859C8.05104 15.2229 7.55256 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17ZM19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17ZM9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7ZM19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 7.55256 15.2229 8.05104 15.5859 8.41406C15.949 8.77709 16.4474 9 17 9C18.1046 9 19 8.10457 19 7ZM21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7ZM21 7C21 9.20914 19.2091 11 17 11C16.2584 11 15.5634 10.7972 14.9678 10.4453L10.4453 14.9678C10.7972 15.5634 11 16.2584 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C7.74116 13 8.43593 13.2022 9.03125 13.5537L13.5537 9.03125C13.2022 8.43593 13 7.74116 13 7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7Z">
                            </path>
                        </svg>
                        <span>3PL Allocation</span>
                    </button>
                    }
                </div>
                @if (orderflows && orderflows?.length > 0) {
                <div class="ad-od-card__body">
                    <div class="ad-od-timeline">
                        @for(flow of orderflowsDesc; track flow.__rowKey; let i = $index; let isLast = $last){
                        <div class="ad-order-status ad-od-tl-item" style="cursor: pointer;"
                            (click)="getLocationDetail(flow)"
                            [ngClass]="'status-' + flow.order_status_id + (!getKm(flow) ? ' ad-order-pb-0' : '')">
                            <!-- The delivery staff profile -->
                            @if(flow.__riderIcon){
                            <div class="ad-od-tl-marker ad-od-tl-marker--logo">
                                <img [src]="flow.__riderIcon" alt="status-icon"
                                    (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                            </div>
                            } @else {
                            <div class="ad-od-tl-marker">
                                <span>{{
                                    constant.OrderStatusName[flow?.order_status_id === 8 ? 23 :
                                    flow.order_status_id][0] }}</span>
                            </div>
                            }
                            <div class="ad-od-tl-body">
                                <div class="ad-od-tl-head">
                                    <div class="d-flex align-items-center gap-2">
                                        <p class="ad-od-tl-title">{{
                                            constant.OrderStatusName[flow?.order_status_id === 8 ? 23 :
                                            flow.order_status_id]
                                            }}</p>
                                        @if(flow.order_status_id !== constant.OrderStatusId.pending && flow.user_id !=
                                        null && flow.delivery_staff_id != null){
                                        @if(flow.user_id == 1){
                                        <span class="ad-manual-assign-badge" container="body" placement="top"
                                            ngbTooltip="This status was updated by the system.">System</span>
                                        } @else {
                                        @if(flow.order_status_id == constant.OrderStatusId.cancelled &&
                                        orderData?.vendor_user_id != flow.user_id){
                                        <span class="ad-manual-assign-badge is-manual" container="body" placement="top"
                                            ngbTooltip="This status was manually updated.">
                                            Manual</span>
                                        }@else if(flow.order_status_id != constant.OrderStatusId.cancelled &&
                                        orderData?.vendor_user_id != flow.user_id){
                                        <span class="ad-manual-assign-badge is-manual" container="body" placement="top"
                                            ngbTooltip="This status was manually updated.">
                                            Manual</span>
                                        }
                                        }
                                        }@else {
                                        @if(flow.order_status_id == constant.OrderStatusId.cancelled){
                                        @if(flow.user_id == 1){
                                        <span class="ad-manual-assign-badge" container="body" placement="top"
                                            ngbTooltip="This status was updated by the system.">System</span>
                                        }
                                        }
                                        }
                                    </div>
                                </div>
                                <div class="d-flex flex-column">
                                    <!-- @if(flow.order_status_id === constant.OrderStatusId.assigned &&
                                    getFlowPartnerName(flow)){
                                    <p class="ad-rca-tracking-rider">{{ getFlowPartnerName(flow) }}</p>
                                    } -->
                                    <div class="ad-od-tl-meta">
                                        <p class="ad-od-tl-time">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor" aria-hidden="true">
                                                <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z">
                                                </path>
                                            </svg>
                                            <span>{{ orderDateFormat(flow.date_time, 'DD MMM YYYY - HH:mm:ss') }}</span>
                                        </p>
                                        @if(getKm(flow); as km){
                                        <p class="ad-od-tl-gap">
                                            <!-- Route glyph: distance from the rider to pickup/drop. -->
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor" fill-rule="evenodd" aria-hidden="true">
                                                <path
                                                    d="M4 15V8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5V15.5C13 16.8807 14.1193 18 15.5 18C16.8807 18 18 16.8807 18 15.5V8.82929C16.8348 8.41746 16 7.30622 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6C22 7.30622 21.1652 8.41746 20 8.82929V15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5V8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5V15H9L5 20L1 15H4ZM19 7C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5C18.4477 5 18 5.44772 18 6C18 6.55228 18.4477 7 19 7Z">
                                                </path>
                                            </svg>
                                            <span>{{ km }}</span>
                                        </p>
                                        }
                                    </div>
                                    <!-- Delivery staff (Assigned rows): own line under time/distance.
                                         span/a, not p: the global .ad-order-status.status-N p rule
                                         would repaint a <p> in the status colour. -->
                                    @if(getFlowRider(flow); as rider){
                                    <div class="ad-od-tl-staff">
                                        @if(rider.full_name){
                                        <span class="ad-od-tl-staff__item ad-od-tl-staff__name"
                                            [title]="rider.full_name">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor" fill-rule="evenodd" aria-hidden="true">
                                                <path
                                                    d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z">
                                                </path>
                                            </svg>
                                            <span class="ad-od-tl-staff__text">{{ rider.full_name }}</span>
                                        </span>
                                        }
                                        @if(rider.full_name && rider.phone){
                                        <span class="ad-od-tl-staff__sep" aria-hidden="true"></span>
                                        }
                                        @if(rider.phone){
                                        <a class="ad-od-tl-staff__item ad-od-tl-staff__phone"
                                            [href]="'tel:' + rider.phone" [attr.aria-label]="'Call ' + rider.phone"
                                            (click)="$event.stopPropagation()">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor" aria-hidden="true">
                                                <path
                                                    d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z">
                                                </path>
                                            </svg>
                                            <span class="ad-od-tl-staff__text">{{ rider.phone }}</span>
                                        </a>
                                        }
                                    </div>
                                    }
                                    @if(getPendingRevertReason(flow, orderflows.length - 1 - i); as reason){
                                    @let chip = getRevertReasonChip(reason);
                                    <p class="ad-rca-tracking-reason" [ngClass]="'is-' + chip.kind"
                                        [ngbTooltip]="chip.hint" placement="top" container="body">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                            @switch (chip.kind) {
                                            @case ('cancelled') { <path d="M18 6 6 18M6 6l12 12"></path> }
                                            @case ('reassign') {
                                            <!-- Filled glyph inside the chip's stroked svg: fill/stroke set per path. -->
                                            <path fill="currentColor" stroke="none"
                                                d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z">
                                            </path>
                                            }
                                            @default { <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M12 16v-4M12 8h.01"></path> }
                                            }
                                        </svg>
                                        <span>{{ chip.label }}</span>
                                    </p>
                                    }
                                </div>
                                <div class="ad-od-tl-aside">

                                    @if(getKm(flow)){
                                    <a class="ad-od-tl-track" ngbTooltip="Map view" container="body"
                                        (click)="googleMapLink(flow)">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20"
                                            viewBox="0 0 48 48">
                                            <path fill="#48b564"
                                                d="M35.76,26.36h0.01c0,0-3.77,5.53-6.94,9.64c-2.74,3.55-3.54,6.59-3.77,8.06	C24.97,44.6,24.53,45,24,45s-0.97-0.4-1.06-0.94c-0.23-1.47-1.03-4.51-3.77-8.06c-0.42-0.55-0.85-1.12-1.28-1.7L28.24,22l8.33-9.88	C37.49,14.05,38,16.21,38,18.5C38,21.4,37.17,24.09,35.76,26.36z">
                                            </path>
                                            <path fill="#fcc60e"
                                                d="M28.24,22L17.89,34.3c-2.82-3.78-5.66-7.94-5.66-7.94h0.01c-0.3-0.48-0.57-0.97-0.8-1.48L19.76,15	c-0.79,0.95-1.26,2.17-1.26,3.5c0,3.04,2.46,5.5,5.5,5.5C25.71,24,27.24,23.22,28.24,22z">
                                            </path>
                                            <path fill="#2c85eb"
                                                d="M28.4,4.74l-8.57,10.18L13.27,9.2C15.83,6.02,19.69,4,24,4C25.54,4,27.02,4.26,28.4,4.74z">
                                            </path>
                                            <path fill="#ed5748"
                                                d="M19.83,14.92L19.76,15l-8.32,9.88C10.52,22.95,10,20.79,10,18.5c0-3.54,1.23-6.79,3.27-9.3	L19.83,14.92z">
                                            </path>
                                            <path fill="#5695f6"
                                                d="M28.24,22c0.79-0.95,1.26-2.17,1.26-3.5c0-3.04-2.46-5.5-5.5-5.5c-1.71,0-3.24,0.78-4.24,2L28.4,4.74	c3.59,1.22,6.53,3.91,8.17,7.38L28.24,22z">
                                            </path>
                                        </svg>
                                        <span>Track</span>
                                    </a>
                                    }
                                </div>

                            </div>
                            <div class="ad-od-tl-rail" *ngIf="!isLast"></div>
                        </div>
                        }
                    </div>
                    @if (orderData?.OrderStatus?.order_status_id === constant.OrderStatusId.assigned ||
                    orderData?.OrderStatus?.order_status_id === constant.OrderStatusId.arrivedAtPickup) {
                    <div class="ad-reassign-wrapper">
                        <p class="ad-reassign-wrapper__hint">Rider delayed or unreachable? Assign someone else.</p>
                        <button type="button" class="ad-reassign-btn" (click)="reassignOrder('open')">
                            <svg class="ad-reassign-btn__icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                            </svg>
                            <span>Reassign Rider</span>
                        </button>
                    </div>
                    }
                </div>
                <!-- @if(dpData?.integratedresponse?.length == 0 && dpData?.orderFlow?.length ||
                    dpData?.integratedresponse?.length == 0 && dpData?.orderFlowDump?.length) {
                      
                    <p class="ad-manually-assigned">Manually Assigned</p>
                    } -->
                <!-- @else {
                    <p class="ad-manually-assigned">Auto Assigned</p>
                    } -->

                }
                @if (orderData?.OrderStatus?.order_status_id == 3 ||orderData?.OrderStatus?.order_status_id ==11) {
                <!-- <div class="mt-2 text-center">
                    <button type="button"class="btn btn-info" (click)="reassignOrder('open')"> Re-Assign</button>
                    </div> -->
                }
            </div>
            }

            <!-- 3PL Allocation bottom sheet — scoped to THIS column  -->
            @if(show3plSheet){
            <div class="ad-3pl-sheet" [class.is-closing]="is3plSheetClosing" (click)="close3plSheet()">
                <div class="ad-3pl-sheet__panel" #threePlSheetEl role="dialog" aria-modal="true"
                    aria-label="3PL Allocation" (click)="$event.stopPropagation()"
                    (keydown)="on3plSheetKeydown($event)">
                    <div class="ad-3pl-sheet__handle" aria-hidden="true"></div>

                    <div class="ad-3pl-sheet__head">
                        <div class="ad-od-card__icon is-accent">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                fill="currentColor">
                                <path
                                    d="M9 17C9 16.4474 8.77709 15.949 8.41406 15.5859C8.05104 15.2229 7.55256 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17ZM19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17ZM9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7ZM19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 7.55256 15.2229 8.05104 15.5859 8.41406C15.949 8.77709 16.4474 9 17 9C18.1046 9 19 8.10457 19 7ZM21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7ZM21 7C21 9.20914 19.2091 11 17 11C16.2584 11 15.5634 10.7972 14.9678 10.4453L10.4453 14.9678C10.7972 15.5634 11 16.2584 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C7.74116 13 8.43593 13.2022 9.03125 13.5537L13.5537 9.03125C13.2022 8.43593 13 7.74116 13 7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7Z">
                                </path>
                            </svg>
                        </div>
                        <h4 class="ad-3pl-sheet__title">3PL Allocation</h4>
                        <ng-container *ngTemplateOutlet="threePlStatus"></ng-container>
                        <button type="button" class="ad-3pl-sheet__close" #threePlSheetClose aria-label="Close (Esc)"
                            (click)="close3plSheet()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z">
                                </path>
                            </svg>
                        </button>
                    </div>

                    <div class="ad-3pl-sheet__body">
                        <ng-container *ngTemplateOutlet="threePlTimeline"></ng-container>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="ad-od-panes">
            <div class="ad-od-col ad-od-col--primary">
                <div class="ad-od-slot">
                    <div class="ad-od-card">
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-accent">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                    fill="currentColor">
                                    <path
                                        d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z">
                                    </path>
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">Order Information</h4>
                            @if([orderData?.master_agency_user_id,
                            orderData?.agency_user_id].includes(constant.elefantUserId)){
                            <button class="ad-od-btn ad-od-btn--pill ad-od-btn--glow" (click)="openItemPop()">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    fill="currentColor">
                                    <path
                                        d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z">
                                    </path>
                                </svg>
                                <span>Order Items</span>
                            </button>
                            }
                        </div>

                        <!-- Order Details Section -->
                        <div class="ad-od-card__body">
                            <div class="ad-od-fields">
                                @if(orderData?.delivery_charge != null){
                                <p class="mb-0 ad-od-field">
                                    <span>Ordering Partner</span>
                                    <span class="ad-od-value">
                                        <img class="ad-od-value__logo" [src]="orderingPartnerLogo"
                                            [alt]="orderData?.User?.full_name || 'Ordering partner'"
                                            (error)="onPartnerLogoError($event)">
                                        <span>{{orderData?.User?.full_name || "-"}}</span>
                                    </span>
                                </p>
                                }
                                <p class="mb-0 ad-od-field">
                                    <span>Payment Type</span>
                                    <span>{{ orderData?.payment_type || '' }}</span>
                                </p>
                                @if (orderData?.cod_collected) {
                                <p class="mb-0 ad-od-field">
                                    <span>COD Collected</span>
                                    <span>Yes</span>
                                </p>
                                }
                                @if(orderData?.order_total_price != null){
                                <p class="mb-0 ad-od-field ad-od-field--strong">
                                    <span>Order Price</span>
                                    <span>{{ orderData?.order_total_price || ''
                                        }}</span>
                                </p>
                                }
                                @if(orderData?.delivery_charge != null){
                                <p class="mb-0 ad-od-field ad-od-field--strong">
                                    <span>Delivery Charge</span>
                                    <span>{{ orderData?.delivery_charge || ''
                                        }}</span>
                                </p>
                                }
                                @if(orderData?.ctd_short_date != null){
                                <p class="mb-0 ad-od-field">
                                    <span>
                                        <span class="ad-created-date-ai">
                                            Created
                                            Date</span>
                                    </span>
                                    <span>{{ orderData?.ctd_dt ?
                                        orderDateFormat(orderData?.ctd_dt, constant.dateTimeFullFormat) : ''
                                        }}</span>
                                </p>
                                }
                                <p class="mb-0 ad-od-field">
                                    <span>Category</span>
                                    <span>{{ orderData?.category_name || '' }}</span>
                                </p>
                            </div>
                            @if (orderData?.order_description) {
                            <p class="mb-0 ad-od-field ad-od-well">
                                <span>Order Description</span>
                                <span class="text-ellips-3">{{ orderData?.order_description || '' }}</span>
                            </p>
                            }
                        </div>
                    </div>
                </div>
                <div class="ad-od-stack">
                    <div class="ad-od-slot">
                        <div class="ad-od-card">
                            <div class="ad-od-card__head">
                                <div class="ad-od-card__icon is-accent">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                        fill="currentColor">
                                        <path
                                            d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z">
                                        </path>
                                    </svg>
                                </div>
                                <h4 class="ad-od-card__title">Pickup &amp; Delivery Details</h4>
                            </div>

                            <div class="ad-od-card__body">
                                <div class="ad-od-transit-route">
                                    <div class="ad-od-transit-stop">
                                        <span class="ad-od-transit-stop__node" aria-hidden="true"></span>
                                        <div class="ad-od-transit-stop__body">
                                            <span class="ad-od-transit-stop__tag">Pickup</span>
                                            <div class="ad-od-transit-stop__row">
                                                <div class="ad-od-transit-stop__who">
                                                    <h5>{{ orderData?.pickup_contact_name || '' }}</h5>
                                                    <p>{{ orderData?.pickup_contact_no || '' }}</p>
                                                </div>
                                                <button class="ad-od-callbtn is-warn"
                                                    (click)="makeCall(orderData?.pickup_contact_no || '')">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                        width="16" height="16" fill="currentColor">
                                                        <path
                                                            d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z">
                                                        </path>
                                                    </svg>
                                                    <span>Call</span>
                                                </button>
                                            </div>
                                            <p class="ad-od-transit-stop__address text-ellips-3">
                                                {{ orderData?.pickup_address || '' }}</p>

                                            @if(orderData?.pickup_landmark){
                                            <p class="ad-od-transit-stop__meta">
                                                <span>Landmark</span>
                                                <span>{{ orderData?.pickup_landmark || 'N/A' }}</span>
                                            </p>
                                            }

                                            <button class="ad-od-transit-stop__copy"
                                                (click)="copyToClipboard(orderData?.pickup_lat + ', ' + orderData?.pickup_long, 'Coordinates')">
                                                <span>Coordinates</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                    </path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="ad-od-transit-stop">
                                        <span class="ad-od-transit-stop__node" aria-hidden="true"></span>
                                        <div class="ad-od-transit-stop__body">
                                            <span class="ad-od-transit-stop__tag">Delivery</span>
                                            @if((orderData?.OrderDetail?.fifo_update && orderData?.fulfillment_type ==
                                            constant.fulFillmentType.fifo)|| orderData?.fifo_update &&
                                            orderData?.fulfillment_type ==
                                            constant.fulFillmentType.fifo || orderData?.fulfillment_type ==
                                            constant.fulFillmentType.spsd || orderData?.fulfillment_type ==
                                            constant.fulFillmentType.spmd){
                                            <div class="ad-od-transit-stop__row">
                                                <div class="ad-od-transit-stop__who">
                                                    <h5>{{ orderData?.delivery_contact_name || '' }}</h5>
                                                    <p>{{ orderData?.delivery_contact_no || '' }}</p>
                                                </div>
                                                <button class="ad-od-callbtn"
                                                    (click)="makeCall(orderData?.delivery_contact_no || '')">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                        width="16" height="16" fill="currentColor">
                                                        <path
                                                            d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z">
                                                        </path>
                                                    </svg>
                                                    <span>Call</span>
                                                </button>
                                            </div>
                                            <p class="ad-od-transit-stop__address text-ellips-3">
                                                {{ orderData?.delivery_address || '' }}</p>

                                            @if(orderData?.delivery_landmark){
                                            <p class="ad-od-transit-stop__meta">
                                                <span>Landmark</span>
                                                <span>{{ orderData?.delivery_landmark || 'N/A' }}</span>
                                            </p>
                                            }

                                            <button class="ad-od-transit-stop__copy"
                                                (click)="copyToClipboard(orderData?.delivery_lat + ', ' + orderData?.delivery_long, 'Coordinates')">
                                                <span>Coordinates</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                    </path>
                                                </svg>
                                            </button>
                                            }@else {
                                            <p class="ad-od-transit-stop__fifo">{{ constant.fulFillmentType.fifo }}</p>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div class="ad-od-transit-meta">
                                    <div class="ad-od-transit-meta__row">
                                        <span class="ad-od-transit-meta__label">Expected Pickup</span>
                                        <span class="ad-od-transit-meta__value">
                                            {{ orderDateFormatChange(orderData?.pickup_date_time, 'HH:mm:ss') }}
                                            <span class="ad-od-transit-meta__sep">|</span>
                                            {{ orderDateFormatChange(orderData?.pickup_date_time, 'DD MMM YYYY') }}
                                        </span>
                                    </div>
                                    @if (orderData?.actual_pickup_date_time) {
                                    <div class="ad-od-transit-meta__row">
                                        <span class="ad-od-transit-meta__label-group">
                                            <span class="ad-od-transit-meta__label">Actual Pickup</span>
                                            <button class="ad-od-transit-meta__link"
                                                (click)="copyToClipboard(orderData?.actual_pickup_lat + ', ' + orderData?.actual_pickup_long, 'Actual Pickup Location')">
                                                <span>Coordinates</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                    </path>
                                                </svg>
                                            </button>
                                        </span>
                                        <span class="ad-od-transit-meta__value">
                                            {{ orderDateFormatChange(orderData?.actual_pickup_date_time, 'HH:mm:ss')
                                            }}
                                            <span class="ad-od-transit-meta__sep">|</span>
                                            {{ orderDateFormatChange(orderData?.actual_pickup_date_time, 'DD MMM YYYY')
                                            }}
                                        </span>
                                    </div>
                                    }
                                    @if (orderData?.actual_delivery_lat) {
                                    <div class="ad-od-transit-meta__row">
                                        <span class="ad-od-transit-meta__label-group">
                                            <span class="ad-od-transit-meta__label">Actual Delivery</span>
                                            <button class="ad-od-transit-meta__link"
                                                (click)="copyToClipboard(orderData?.actual_delivery_lat + ', ' + orderData?.actual_delivery_long, 'Actual Delivery Location')">
                                                <span>Coordinates</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2">
                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                    </path>
                                                </svg>
                                            </button>
                                        </span>
                                        <span class="ad-od-transit-meta__value">
                                            {{ orderDateFormatChange(orderData?.delivery_date_time, 'HH:mm:ss') }}
                                            <span class="ad-od-transit-meta__sep">|</span>
                                            {{ orderDateFormatChange(orderData?.delivery_date_time, 'DD MMM YYYY') }}
                                        </span>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                @if((supportTicket?.length > 0) || (riderSupport?.length > 0)){
                <div class="ad-od-slot">
                    <div class="ad-od-card">
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-warn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                    fill="currentColor">
                                    <path
                                        d="M22 17.0022C21.999 19.8731 19.9816 22.2726 17.2872 22.8616L16.6492 20.9476C17.8532 20.7511 18.8765 20.0171 19.4649 19H17C15.8954 19 15 18.1046 15 17V13C15 11.8954 15.8954 11 17 11H19.9381C19.446 7.05369 16.0796 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11H7C8.10457 11 9 11.8954 9 13V17C9 18.1046 8.10457 19 7 19H4C2.89543 19 2 18.1046 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.9987V13V17V17.0013V17.0022ZM20 17V13H17V17H20ZM4 13V17H7V13H4Z">
                                    </path>
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">Support Ticket</h4>
                            <span class="px-2 small ad-od-card__aside ad-od-badge ad-od-badge--warn">Support</span>
                        </div>

                        <div class="ad-od-card__body">
                            @if(supportTicket?.length > 0){
                            <div class="ad-od-list">
                                <div class="ad-od-list__head">Support from Adloggs</div>
                                @for(ticket of supportTicket; track ticket.order_comment_id){
                                <div class="ad-od-list__row">
                                    <p>{{ ticket.order_flow_comment }}</p>
                                    <p>{{ ticket.ctd_dt_ist }}</p>
                                </div>
                                }
                            </div>
                            }

                            @if(riderSupport?.length > 0){
                            <div class="ad-od-list">
                                <div class="ad-od-list__head">Rider Support</div>
                                @for(ticket of riderSupport; track ticket.dp_logs_id){
                                <div class="ad-od-list__row">
                                    <p>{{ ticket.message }}</p>
                                    <p>{{ ticket.ctd_dt_ist }}</p>
                                </div>
                                }
                            </div>
                            }
                        </div>

                    </div>
                </div>
                }
            </div>
            <div class="ad-od-col ad-od-col--secondary">
                @if(loggiSuggestion != ''){
                <div class="ad-od-card">
                    <div class="ad-od-card__head">
                        <h4 class="ad-od-card__title">AI Suggestion</h4>
                        <div class="ad-od-card__aside">
                            <span>
                                <img src="assets/images/loggiai.svg" alt="loggiai">
                            </span>
                        </div>
                    </div>
                    <div class="ad-od-card__body">
                        <div class="ad-od-note">
                            <div>Route Update</div>
                            <p>{{loggiSuggestion}}</p>
                        </div>
                    </div>
                </div>
                }
                @if (notificationList?.length != 0 ) {
                <div class="ad-od-card">
                    <div class="ad-od-card__head">
                        <div class="ad-notification-icon ad-od-card__icon is-info">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                fill="currentColor">
                                <path
                                    d="M13.3414 4C13.1203 4.62556 13 5.29873 13 6H5V20H19V12C19.7013 12 20.3744 11.8797 21 11.6586V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H13.3414ZM19 8C20.1046 8 21 7.10457 21 6C21 4.89543 20.1046 4 19 4C17.8954 4 17 4.89543 17 6C17 7.10457 17.8954 8 19 8ZM19 10C16.7909 10 15 8.20914 15 6C15 3.79086 16.7909 2 19 2C21.2091 2 23 3.79086 23 6C23 8.20914 21.2091 10 19 10Z">
                                </path>
                            </svg>
                        </div>
                        <h4 class="ad-od-card__title">Notification</h4>
                    </div>
                    <div class="ad-od-card__body">
                        @if (notificationList?.length != 0 ) {
                        @for(notify of notificationList; track notify.__rowKey; let i = $index){
                        <div class="ad-od-notify">
                            <div class="ad-od-notify__top">
                                <h5 class="ad-od-notify__name">{{ notify?.DeliveryStaff?.full_name || 'N/A' }}</h5>
                                <span class="ad-od-notify__count">Counts ({{ notify?.count_notify || 0 }})</span>
                            </div>
                            <p class="ad-od-notify__meta">
                                <span>{{ notify?.DeliveryStaff?.Agency != null ?
                                    notify?.DeliveryStaff?.Agency?.full_name :
                                    notify?.DeliveryStaff?.MasterAgency?.full_name }}</span>
                                <span class="ad-od-notify__sep" aria-hidden="true">&bull;</span>
                                <span>{{ commonLogics.getCustomLabel('Agency') }}</span>
                            </p>
                        </div>

                        }
                        }@else {
                        <div class="ad-od-empty">
                            <h5 class="mb-2">No Notification Found</h5>
                        </div>
                        }
                    </div>
                </div>
                }
                <div class="ad-od-card">
                    <!-- Header Section -->
                    <div class="ad-od-card__head">
                        <div class="ad-od-card__icon is-accent">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                fill="currentColor">
                                <path
                                    d="M2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979ZM14.0049 4.99979H4.00488V7.96755C5.4866 8.7039 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H14.0049V4.99979ZM16.0049 4.99979V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H16.0049Z">
                                </path>
                            </svg>
                        </div>
                        <h4 class="ad-od-card__title">Create Ticket</h4>
                        <div class="ad-od-card__aside">
                            <button class="ad-od-btn ad-od-btn--pill ad-od-btn--glow" (click)="generateIGM()">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    fill="currentColor">
                                    <path
                                        d="M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z">
                                    </path>
                                </svg>
                                <span>
                                    {{commonLogics.roleCtrl([constant.RoleId.masterAgency, constant.RoleId.agency],
                                    'checkRoleIsEqual')
                                    && !dataNullCheck ? 'View IGM' : (orderData?.delivery_partner_user_id == 2777 ?
                                    'Generate IGM' : 'Generate Issue Ticket')}}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>


                @if(hasObjectKeys(deliveryStaff) && deliveryStaff?.phone){
                <div class="ad-od-card">
                    <!-- Header Section -->
                    <div class="ad-od-card__head">
                        <div class="ad-od-card__icon ad-od-card__icon--photo is-accent">
                            @if(deliveryStaff.dp_url && deliveryStaff.dp_url != ""){
                            <img src={{deliveryStaff.dp_url}} alt="Rider Profile"
                                (error)="$any($event.target).src='assets/images/avatar/3pl/avatar.jpg'">
                            } @else {
                            <img src="assets/images/avatar/3pl/avatar.jpg" alt="Rider Profile">
                            }
                        </div>
                        <h4 class="ad-od-card__title">Delivery Staff Details</h4>
                        <div class="ad-od-card__aside">
                            <img src={{lastStatus.iconUrl}} alt="status-icon"
                                (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                            <span>{{deliveryStaff?.delivery_partner_name}}</span>
                        </div>
                    </div>
                    <div class="ad-od-card__body">
                        <div class="ad-od-contact">
                            <div class="ad-od-contact__info">
                                <h3 class="ad-od-contact__name">
                                    {{ deliveryStaff.full_name || '' }}
                                </h3>
                                <p class="ad-od-contact__phone">{{ deliveryStaff.phone || '' }}</p>
                            </div>
                            <!-- Actions ride the contact row rather than a strip of their own:
                                 they act on the person named beside them. -->
                            <div class="ad-od-contact__actions">
                                <button class="ad-od-callbtn" (click)="makeCall(deliveryStaff.phone || '')">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"
                                        fill="currentColor">
                                        <path
                                            d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z">
                                        </path>
                                    </svg>
                                    <span>Call</span>
                                </button>
                                <!-- @if(!commonLogics.roleCtrl([constant.RoleId.vendor], 'checkRoleIsEqual')){ -->
                                @if(canBlockRider){
                                <span [ngbTooltip]="'This rider not blocked your end'"
                                    [disableTooltip]="!buttonDisabled" placement="bottom">
                                    <button class="ad-od-btn ad-od-btn--tone ad-od-btn--danger ad-od-btn--pill"
                                        (click)="blockPopup()" [disabled]="buttonDisabled">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                            height="24" fill="currentColor">
                                            <path
                                                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 10.1786 19.3912 8.49927 18.3656 7.15332L7.15332 18.3656C8.49927 19.3912 10.1786 20 12 20ZM5.63441 16.8467L16.8467 5.63441C15.5007 4.60883 13.8214 4 12 4C7.58172 4 4 7.58172 4 12C4 13.8214 4.60883 15.5007 5.63441 16.8467Z">
                                            </path>
                                        </svg>
                                        <span>Block</span>
                                    </button>
                                </span>
                                }
                            </div>
                        </div>
                        <!-- Rider Info Section -->
                        @if(deliveryStaff?.agencyName || this.reqfor != 'history'){
                        <div class="ad-od-fields">
                            @if(deliveryStaff?.agencyName){
                            <div class="ad-od-field">
                                <span>{{ commonLogics.getCustomLabel('Agency') }} Name</span>
                                <span>{{deliveryStaff?.agencyName}}</span>
                            </div>
                            }
                            <!-- @if (this.reqfor != 'history') {
                            <div class="ad-od-field">
                                <span>Current Location</span>
                                <span class="ad-od-value">
                                    <button class="ad-od-transit-stop__copy"
                                        (click)="copyToClipboard(latLngFixed(orderData?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.lat, 6) + ', ' + latLngFixed(orderData?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.long, 6), 'Current Location')">
                                        <span>Coordinates</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                            </path>
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            } -->
                        </div>
                        }
                    </div>
                </div>
                }

                @if (orderData?.DeliveryPartner) {
                <div class="ad-od-slot">
                    <div class="ad-od-card">
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-accent">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                    fill="currentColor">
                                    <path
                                        d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L13.0001 11.4234V20.11L19.5 16.3469V7.65311L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329Z">
                                    </path>
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">Delivery Partner Details</h4>
                        </div>
                        <div class="ad-od-card__body">
                            <div class="ad-od-fields">
                                <div class="ad-od-field">
                                    <span>Partner Name</span>
                                    <span class="ad-od-value">
                                        <!-- The same image the card header used to
                                             carry. lastStatus.iconUrl, not
                                             DeliveryPartner.icon_url: only the
                                             former has been prefixed with
                                             ImageUrl.BaseUrl + ShowImage (see
                                             getDeliveryPartnerData), so the raw
                                             field alone resolves to nothing. -->
                                        <img class="ad-od-value__logo" src={{lastStatus.iconUrl}}
                                            [alt]="orderData?.DeliveryPartner?.full_name || 'Delivery partner'"
                                            (error)="$any($event.target).src='assets/images/avatar/3pl/default.png'">
                                        <span>{{ orderData?.DeliveryPartner?.full_name ||
                                            'N/A' }}@if(orderData?.OrderDetail?.rider_platform_name ||
                                            orderData?.rider_platform_name){ - {{
                                            orderData?.OrderDetail?.rider_platform_name
                                            ||
                                            orderData?.rider_platform_name || 'N/A' }}}</span>
                                    </span>
                                </div>
                                @if(orderData?.DeliveryPartner?.user_id){
                                <div class="ad-od-field">
                                    <span>Partner ID</span>
                                    <span class="ad-od-value">
                                        <span>{{ orderData?.DeliveryPartner?.user_id || 'N/A' }}</span>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(orderData?.DeliveryPartner?.user_id, 'Partner ID')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </span>
                                </div>
                                }
                                @if(orderData?.delivery_partner_order_id){
                                <div class="ad-od-field">
                                    <span>Delivery Partner Order ID</span>
                                    <span class="ad-od-value">
                                        <span class="ad-text-limit" [title]="orderData?.delivery_partner_order_id"><span
                                                class="ad-id-head">{{commonLogics.truncateMiddleParts(orderData?.delivery_partner_order_id).head}}</span><span
                                                class="ad-id-tail">{{commonLogics.truncateMiddleParts(orderData?.delivery_partner_order_id).tail}}</span></span>
                                        <button type="button" class="ad-od-iconbtn"
                                            aria-label="Copy Delivery Partner Order ID"
                                            (click)="copyToClipboard(orderData?.delivery_partner_order_id, 'Delivery Partner Order ID')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                }@else{
                @if (orderData?.OrderDetail?.delivery_partner_rider_dtl || orderData?.rider_name ||
                orderData?.rider_phone) {
                <div class="ad-od-slot">
                    <div class="ad-od-card">
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-route">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="currentColor">
                                    <path
                                        d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z">
                                    </path>
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">Delivery Partner Details</h4>
                        </div>
                        <div class="ad-od-card__body">
                            <div class="ad-od-fields">
                                <div class="ad-od-field">
                                    <p>Rider Name</p>
                                    <p>{{
                                        orderData?.OrderDetail?.delivery_partner_rider_dtl?.full_name ??
                                        orderData?.rider_name ?? 'N/A'}}
                                    </p>
                                </div>
                                <div class="ad-od-field">
                                    <p>Rider Phone</p>
                                    <p>{{
                                        orderData?.OrderDetail?.delivery_partner_rider_dtl?.phone ??
                                        orderData?.rider_phone ?? 'N/A' }}
                                    </p>
                                </div>
                                @if (orderData?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation) {
                                <div class="ad-od-field ad-od-field--full">
                                    <p>Current Location</p>
                                    <p>{{
                                        latLngFixed(orderData?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.lat,
                                        6)
                                        +
                                        ', '
                                        +
                                        latLngFixed(orderData?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.long,
                                        6)
                                        }}
                                    </p>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                }
                }
                @if( orderData?.OrderDetail?.pickup_otp != null || orderData?.OrderDetail?.delivery_otp != null ||
                orderData?.OrderDetail?.return_to_pickup_otp != null ||
                orderData?.OrderDetail?.return_otp_sent_by_cus
                != null){
                <div class="ad-od-slot">
                    <!-- OTP Details Card Start-->
                    <div class="ad-od-card">
                        <!-- Header Section -->
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-info">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                                    fill="currentColor">
                                    <path
                                        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 12.792C10.117 12.4062 9.5 11.5252 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.5252 13.883 12.4062 13 12.792V16H11V12.792Z">
                                    </path>
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">OTP Details</h4>
                        </div>
                        <!-- OTP Content Section Start-->
                        <div class="ad-od-card__body">
                            <div class="ad-od-fields ad-od-fields--row">
                                @if( orderData?.OrderDetail?.pickup_otp ||
                                orderData?.OrderDetail?.pickup_otp_sent_by_cus){
                                <div class="ad-od-field ad-od-field--strong">
                                    <p class="mb-0">Pick Up</p>
                                    <h4 class="ad-od-value">
                                        <span>{{ orderData?.OrderDetail?.pickup_otp_sent_by_cus ||
                                            orderData?.OrderDetail?.pickup_otp || '-' }}</span>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(orderData?.OrderDetail?.pickup_otp_sent_by_cus || orderData?.OrderDetail?.pickup_otp, 'Pickup OTP')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </h4>
                                </div>
                                } @if( orderData?.OrderDetail?.delivery_otp ||
                                orderData?.OrderDetail?.delivery_otp_sent_by_cus){
                                <div class="ad-od-field ad-od-field--strong">
                                    <p class="mb-0">Drop</p>
                                    <h4 class="ad-od-value">
                                        <span>{{ orderData?.OrderDetail?.delivery_otp_sent_by_cus ||
                                            orderData?.OrderDetail?.delivery_otp || '-' }}</span>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(orderData?.OrderDetail?.delivery_otp_sent_by_cus || orderData?.OrderDetail?.delivery_otp, 'Drop OTP')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </h4>
                                </div>
                                }
                                @if ( orderData?.OrderDetail?.return_to_pickup_otp ||
                                orderData?.OrderDetail?.return_otp_sent_by_cus){
                                <div class="ad-od-field ad-od-field--strong">
                                    <p class="mb-0">RTO</p>
                                    <h4 class="ad-od-value">
                                        <span>{{ orderData?.OrderDetail?.return_otp_sent_by_cus ||
                                            orderData?.OrderDetail?.return_to_pickup_otp || '-'
                                            }}</span>
                                        <button class="ad-od-iconbtn"
                                            (click)="copyToClipboard(orderData?.OrderDetail?.return_otp_sent_by_cus || orderData?.OrderDetail?.return_to_pickup_otp, 'RTO OTP')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">
                                                </path>
                                            </svg>
                                        </button>
                                    </h4>
                                </div>
                                }
                            </div>
                        </div>
                        <!-- OTP Content Section End-->
                    </div>
                    <!-- OTP Details Card End-->
                </div>
                }
                @if(hasObjectKeys(cancelledBy || {})){
                <div class="ad-od-slot">
                    <!-- Cancelled by Information Card -->
                    <div class="ad-od-card">
                        <!-- Header Section -->
                        <div class="ad-od-card__head">
                            <div class="ad-od-card__icon is-danger">
                                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                                    <path fill="currentColor" fill-rule="evenodd"
                                        d="M256 42.667c117.821 0 213.334 95.513 213.334 213.333c0 117.821-95.513 213.334-213.334 213.334c-117.82 0-213.333-95.513-213.333-213.334C42.667 138.18 138.18 42.667 256 42.667M85.334 256c0 94.257 76.41 170.667 170.666 170.667c39.44 0 75.754-13.378 104.654-35.843L121.177 151.347C98.71 180.247 85.334 216.56 85.334 256M256 85.334c-39.439 0-75.753 13.377-104.653 35.843l239.477 239.477c22.465-28.9 35.843-65.214 35.843-104.654c0-94.256-76.41-170.666-170.667-170.666" />
                                </svg>
                            </div>
                            <h4 class="ad-od-card__title">Cancelled by</h4>
                            <div class="ad-od-card__aside">
                                <span>{{cancelledBy.date}}</span>
                            </div>
                        </div>

                        <!-- Order Details Section -->
                        <div class="ad-od-card__body">
                            <div class="ad-od-fields">
                                <p class="mb-0 ad-od-field ad-od-field--full">
                                    <span>{{cancelledBy.full_name}}</span>
                                    <span>{{cancelledBy.desc}}</span>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                }
                @if((proof_of_delivery?.includes('.jpeg') || proof_of_delivery?.includes('.jpg') ||
                proof_of_delivery?.includes('.png'))
                || (proof_of_pickup?.includes('.jpeg') || proof_of_pickup?.includes('.jpg') ||
                proof_of_pickup?.includes('.png'))
                || (proof_of_delivery_collection?.includes('.jpeg') || proof_of_delivery_collection?.includes('.jpg') ||
                proof_of_delivery_collection?.includes('.png'))
                ||(proof_of_rto_delivered?.includes('.jpeg') || proof_of_rto_delivered?.includes('.jpg') ||
                proof_of_rto_delivered?.includes('.png'))
                ){
                <div class="ad-od-card">
                    <!-- Header Section -->
                    <div class="ad-od-card__head">
                        <div class="ad-od-card__icon is-neutral">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="currentColor">
                                <path
                                    d="M9.828 5l-2 2H4v12h16V7h-3.828l-2-2H9.828zM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2zm3 15a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z">
                                </path>
                            </svg>
                        </div>
                        <h4 class="ad-od-card__title">Proof Details</h4>
                    </div>

                    <div class="ad-od-card__body">

                        <div class="ad-od-proofs">

                            @if (proof_of_pickup?.includes('.jpeg') || proof_of_pickup?.includes('.jpg') ||
                            proof_of_pickup?.includes('.png')) {
                            <div class="w-100">
                                <div class="proof-label mb-2">
                                    <span>Pickup Proof</span>
                                </div>

                                <div class="ad-form-group ad-screen-shot-wrpper w-100">
                                    <!-- <span > -->
                                    <a class="ad-acreen-download btn ad-btn-small" href="javascript:;"
                                        (click)="DownloadImage(proof_of_pickup,'pickup')">
                                        <i class="icofont icofont-download-alt"></i>
                                    </a>
                                    <!-- </span> -->
                                    <div class="user-image">
                                        <div class="avatar">
                                            <img alt="Pickup proof"
                                                [src]="proof_of_pickup || 'assets/images/no-image.png'">
                                        </div>
                                        <button type="button" class="ad-proof-open"
                                            (click)="openProofViewer(proof_of_pickup, 'Pickup proof', 'pickup')"
                                            aria-label="View pickup proof full screen">
                                            <span class="ad-proof-open__chip">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor">
                                                    <path
                                                        d="M20 3H22V9H20V5H16V3H20ZM4 3H8V5H4V9H2V3H4ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z">
                                                    </path>
                                                </svg>
                                                <span>Full view</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }


                            @if (proof_of_delivery?.includes('.jpeg') || proof_of_delivery?.includes('.jpg')
                            ||proof_of_delivery?.includes('.png')) {
                            <div class="w-100">
                                <div class="proof-label  mb-2">
                                    <span>Delivery Proof</span>
                                </div>
                                <div class="ad-form-group ad-screen-shot-wrpper w-100">
                                    <a class="ad-acreen-download btn ad-btn-small" href="javascript:;"
                                        (click)="DownloadImage(proof_of_delivery,'delivery')">
                                        <i class="icofont icofont-download-alt"></i>
                                    </a>
                                    <div class="user-image">
                                        <div class="avatar">
                                            <img alt="Delivery proof"
                                                [src]="proof_of_delivery || 'assets/images/no-image.png'">
                                        </div>
                                        <button type="button" class="ad-proof-open"
                                            (click)="openProofViewer(proof_of_delivery, 'Delivery proof', 'delivery')"
                                            aria-label="View delivery proof full screen">
                                            <span class="ad-proof-open__chip">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor">
                                                    <path
                                                        d="M20 3H22V9H20V5H16V3H20ZM4 3H8V5H4V9H2V3H4ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z">
                                                    </path>
                                                </svg>
                                                <span>Full view</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>

                        <div class="ad-od-proofs">

                            <!-- @if(constant.live){ -->
                            @if (proof_of_delivery_collection?.includes('.jpeg') ||
                            proof_of_delivery_collection?.includes('.jpg')
                            ||proof_of_delivery_collection?.includes('.png')) {
                            <div class="w-100">
                                <div class="proof-label  mb-2">
                                    <span>Collection Proof</span>
                                </div>
                                <div class="ad-form-group ad-screen-shot-wrpper w-100">
                                    <a class="ad-acreen-download btn ad-btn-small" href="javascript:;"
                                        (click)="DownloadImage(proof_of_delivery_collection,'delivery')">
                                        <i class="icofont icofont-download-alt"></i>
                                    </a>
                                    <div class="user-image">
                                        <div class="avatar">
                                            <img alt="Collection proof"
                                                [src]="proof_of_delivery_collection || 'assets/images/no-image.png'">
                                        </div>
                                        <button type="button" class="ad-proof-open"
                                            (click)="openProofViewer(proof_of_delivery_collection, 'Collection proof', 'delivery')"
                                            aria-label="View collection proof full screen">
                                            <span class="ad-proof-open__chip">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor">
                                                    <path
                                                        d="M20 3H22V9H20V5H16V3H20ZM4 3H8V5H4V9H2V3H4ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z">
                                                    </path>
                                                </svg>
                                                <span>Full view</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }
                            @if (proof_of_rto_delivered?.includes('.jpeg') || proof_of_rto_delivered?.includes('.jpg')
                            ||proof_of_rto_delivered?.includes('.png')) {
                            <div class="w-100">
                                <div class="proof-label  mb-2">
                                    <span>RTO Proof </span>
                                </div>
                                <div class="ad-form-group ad-screen-shot-wrpper w-100">
                                    <a class="ad-acreen-download btn ad-btn-small" href="javascript:;"
                                        (click)="DownloadImage(proof_of_rto_delivered,'delivery')">
                                        <i class="icofont icofont-download-alt"></i>
                                    </a>
                                    <div class="user-image">
                                        <div class="avatar">
                                            <img alt="RTO proof"
                                                [src]="proof_of_rto_delivered || 'assets/images/no-image.png'">
                                        </div>
                                        <button type="button" class="ad-proof-open"
                                            (click)="openProofViewer(proof_of_rto_delivered, 'RTO proof', 'delivery')"
                                            aria-label="View rto proof full screen">
                                            <span class="ad-proof-open__chip">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor">
                                                    <path
                                                        d="M20 3H22V9H20V5H16V3H20ZM4 3H8V5H4V9H2V3H4ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z">
                                                    </path>
                                                </svg>
                                                <span>Full view</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }
                            <!-- } -->
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <!-- ControlX Activities -->
        @if(showControlxPanel){
        <aside class="ad-od-col ad-od-col--activity" [class.is-open]="showControlxSheet" #controlxSheetEl
            aria-label="ControlX activities" (keydown)="onControlxSheetKeydown($event)">
            <div class="ad-controlx-sheet-handle" aria-hidden="true"></div>
            <button type="button" class="ad-controlx-sheet-close" #controlxSheetClose
                aria-label="Close ControlX activities (Esc)" (click)="closeControlxSheet()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z">
                    </path>
                </svg>
            </button>
            <section class="ad-od-activity" [class.is-live]="isOrderLive" [attr.data-stream]="controlxStream">

                <span class="ad-od-activity__glow" aria-hidden="true"></span>
                @if(controlxActivities.length){
                <div class="ad-od-activity__head">

                    <div class="ad-od-activity__mark">
                        <span class="ad-agentic-ai-menu" [class.is-live]="isOrderLive">
                            <img class="ad-od-globe-logo" src="assets/images/globe-ai.png" alt="globe-ai">
                            <img class="ad-od-controlx-logo" src="assets/images/agentic-icons/control-x.png"
                                alt="ControlX-logo">
                        </span>
                        <h4 class="ad-od-activity__title" [title]="controlxStreamLabel">Activities</h4>
                    </div>

                    @if(isOrderLive){
                    <span class="ad-cx-live" [attr.data-stream]="controlxStream" [title]="controlxStreamLabel">
                        <span class="ad-cx-live__dot" aria-hidden="true"></span>
                        <span class="ad-cx-live__think" aria-hidden="true">
                            <span></span><span></span><span></span>
                        </span>
                        <span class="ad-cx-live__text">{{ controlxLiveLabel }}</span>
                    </span>
                    }@else {
                    <span class="ad-cx-done" [ngClass]="'status-' + orderData?.order_status_id">
                        {{ orderStatusLabel }}
                    </span>
                    }
                </div>

                <div class="ad-cx-tabs" role="group" aria-label="Filter activities">
                    @for(tab of controlxTabs; track tab.key){
                    <button type="button" class="ad-cx-tabs__btn" [class.is-active]="controlxTab === tab.key"
                        [attr.aria-pressed]="controlxTab === tab.key" [disabled]="!controlxTabCounts[tab.key]"
                        (click)="setControlxTab(tab.key)">
                        <span class="ad-cx-tabs__label">{{ tab.label }}</span>
                        <span class="ad-cx-tabs__count">{{ controlxTabCounts[tab.key] }}</span>
                    </button>
                    }
                </div>

                <ol class="ad-od-activity__list ad-cx-tl" [class.is-live]="isOrderLive" aria-live="polite"
                    aria-relevant="additions" tabindex="0">
                    @for(activity of controlxVisibleActivities; track activity.id){
                    <li class="ad-cx-tl__row" [class.is-new]="activity.isNew" [attr.data-tone]="activity.tone"
                        [attr.data-prefix]="activity.prefixTone" [attr.data-severity]="activity.severity"
                        [attr.data-category]="activity.category || null" [attr.data-source]="activity.source || null">

                        <span class="ad-cx-tl__node" aria-hidden="true" [title]="activity.toneLabel">
                            @switch (activity.iconKey) {
                            @case ('alert') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                <path d="M12 9v4M12 17h.01" />
                            </svg>
                            }
                            @case ('clock') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="9" />
                                <path d="M12 7v5l3 2" />
                            </svg>
                            }
                            @case ('comms') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                            </svg>
                            }
                            @case ('ticket') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z" />
                                <path d="M13 5v14" stroke-dasharray="2 3" />
                            </svg>
                            }
                            @case ('package') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                <path d="m3.3 7 8.7 5 8.7-5M12 22V12" />
                            </svg>
                            }
                            @case ('brain') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M12 5a3 3 0 0 0-3 3 3 3 0 0 0-1 5.8A2.5 2.5 0 0 0 10.5 19 2.5 2.5 0 0 0 12 18.5z" />
                                <path
                                    d="M12 5a3 3 0 0 1 3 3 3 3 0 0 1 1 5.8A2.5 2.5 0 0 1 13.5 19 2.5 2.5 0 0 1 12 18.5z" />
                            </svg>
                            }
                            @case ('tool') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M14.7 6.3a4 4 0 0 1 5 5l-9.4 9.4a2 2 0 0 1-2.8-2.8l9.4-9.4a2 2 0 0 0-2.8-2.8L4.7 15.1a6 6 0 0 0 8.5 8.5" />
                            </svg>
                            }
                            @case ('shield') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            }
                            @default {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <rect x="6" y="6" width="12" height="12" rx="2.5" />
                                <path d="M10 10h4v4h-4z" />
                                <path d="M9 3v2M15 3v2M9 19v2M15 19v2M3 9h2M3 15h2M19 9h2M19 15h2" />
                            </svg>
                            }
                            }
                        </span>

                        <article class="ad-cx-card" [title]="activity.contextTitle">
                            <span class="visually-hidden">{{ activity.toneLabel }}.</span>
                            <header class="ad-cx-card__top">
                                <span class="ad-cx-card__tags">
                                    @if(activity.prefixLabel){
                                    <span class="ad-cx-badge">{{ activity.prefixLabel }}</span>
                                    }
                                    @if(activity.sourceLabel){
                                    <span class="ad-cx-badge ad-cx-badge--soft">{{ activity.sourceLabel }}</span>
                                    }
                                </span>
                                @if(activity.timeLabel){
                                <time class="ad-cx-card__time" [title]="activity.timeTitle">{{ activity.timeLabel
                                    }}</time>
                                }
                            </header>

                            <p class="ad-cx-card__msg">{{ activity.message }}</p>

                            @if(activity.detailText){
                            <div class="ad-cx-reason">
                                <svg class="ad-cx-reason__mark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                </svg>
                                <p class="ad-cx-reason__text">{{ activity.detailText }}</p>
                            </div>
                            }

                            @if(activity.agentDisplayName || activity.statusLabel || activity.confidence !== null){
                            <footer class="ad-cx-card__foot">
                                @if(activity.agentDisplayName){
                                <span class="ad-cx-who">
                                    <span class="ad-cx-who__avatar" aria-hidden="true">{{ activity.agentInitials
                                        }}</span>
                                    <span class="ad-cx-who__body">
                                        <span class="ad-cx-who__name">{{ activity.agentDisplayName }}</span>
                                        @if(activity.agentRaw){
                                        <span class="ad-cx-who__raw">{{ activity.agentRaw }}</span>
                                        }
                                    </span>
                                </span>
                                }

                                @if(activity.statusLabel){
                                <span class="ad-cx-status">{{ activity.statusLabel }}</span>
                                }

                                @if(activity.confidence !== null){
                                <span class="ad-cx-conf"
                                    [attr.aria-label]="'Confidence ' + activity.confidence + ' percent'">
                                    <svg class="ad-cx-conf__ring" viewBox="0 0 36 36" aria-hidden="true">
                                        <circle class="ad-cx-conf__track" cx="18" cy="18" r="15.5" />
                                        <circle class="ad-cx-conf__bar" cx="18" cy="18" r="15.5"
                                            [attr.stroke-dasharray]="activity.confidenceDash" />
                                    </svg>
                                    <span class="ad-cx-conf__body">
                                        <span class="ad-cx-conf__num">{{ activity.confidence }}%</span>
                                        <span class="ad-cx-conf__cap">CONF</span>
                                    </span>
                                </span>
                                }
                            </footer>
                            }
                        </article>
                    </li>
                    }
                </ol>
                }@else {
                <div class="ad-od-activity__empty">
                    <img src="assets/images/agentic-icons/control-x.png" alt="ControlX" class="ad-od-activity__logo">
                    <p class="ad-od-activity__brand">The ControlX</p>
                    <p class="ad-od-activity__caption" [title]="controlxStreamLabel">{{ controlxEmptyCaption }}</p>
                </div>
                }
            </section>
        </aside>
        <div class="ad-controlx-sheet-backdrop" [class.is-open]="showControlxSheet" (click)="closeControlxSheet()">
        </div>
        }
    </div>
</div>

<!-- ControlX floating trigger  -->
@if(showControlxPanel){
<button type="button" class="ad-cx-fab" [class.is-open]="showControlxSheet" (click)="toggleControlxSheet()"
    [attr.aria-expanded]="showControlxSheet" aria-label="ControlX activities">
    <span class="ad-agentic-ai-menu" [class.is-live]="isOrderLive" aria-hidden="true">
        <img class="ad-od-globe-logo" src="assets/images/globe-ai.png" alt="">
        <img class="ad-od-controlx-logo" src="assets/images/agentic-icons/control-x.png" alt="">
    </span>
    <span class="ad-cx-fab__label">Activities</span>
</button>
}

<!-- Mobile app-style footer nav  -->
@if(showControlxPanel){
<nav class="ad-od-mobile-nav" aria-label="Order panels">
    @if(has3plAllocation && !isBeforeAssigned){
    <button type="button" class="ad-od-mobile-nav__btn" (click)="open3plSheet()" [attr.aria-pressed]="show3plSheet">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path
                d="M9 17C9 16.4474 8.77709 15.949 8.41406 15.5859C8.05104 15.2229 7.55256 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17ZM19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17ZM9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7ZM19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 7.55256 15.2229 8.05104 15.5859 8.41406C15.949 8.77709 16.4474 9 17 9C18.1046 9 19 8.10457 19 7ZM21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7ZM21 7C21 9.20914 19.2091 11 17 11C16.2584 11 15.5634 10.7972 14.9678 10.4453L10.4453 14.9678C10.7972 15.5634 11 16.2584 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C7.74116 13 8.43593 13.2022 9.03125 13.5537L13.5537 9.03125C13.2022 8.43593 13 7.74116 13 7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7Z">
            </path>
        </svg>
        <span>3PL Allocation</span>
    </button>
    }
    <button type="button" class="ad-od-mobile-nav__btn" (click)="openControlxSheet()"
        [attr.aria-pressed]="showControlxSheet">
        <img src="assets/images/agentic-icons/control-x.png" alt="" class="ad-od-mobile-nav__icon-img">
        <span>ControlX Activity</span>
    </button>
</nav>
}

<!-- Proof lightbox. -->
@if(proofViewer){
<div class="ad-proof-view" #proofViewerEl role="dialog" aria-modal="true" [attr.aria-label]="proofViewer.label"
    (click)="closeProofViewer()" (keydown)="onProofViewerKeydown($event)">

    <div class="ad-proof-view__bar" (click)="$event.stopPropagation()">
        <p class="ad-proof-view__title">{{ proofViewer.label }}</p>

        <div class="ad-proof-view__actions">
            <button type="button" class="ad-od-btn ad-od-btn--solid ad-od-btn--accent ad-od-btn--pill"
                (click)="DownloadImage(proofViewer.src, proofViewer.name)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M13 10h5l-6 6-6-6h5V3h2v7zM4 19h16v2H4v-2z"></path>
                </svg>
                <span>Download</span>
            </button>

            <button type="button" class="ad-proof-view__close" #proofViewerClose aria-label="Close image viewer (Esc)"
                (click)="closeProofViewer()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z">
                    </path>
                </svg>
            </button>
        </div>
    </div>

    <div class="ad-proof-view__stage">
        <img class="ad-proof-view__img" [src]="proofViewer.src" [alt]="proofViewer.label"
            (click)="$event.stopPropagation()">
    </div>
</div>
}
}@else {
<div class="ad-nodata-found">
    <div class="text-center">
        <object data="assets/images/no-data-found.svg" type="image/svg+xml" alt="Empty image"
            class="ad-no-data-svg"></object>
        <h3 class="mb-2">Order Not Found</h3>
        <p class="text-muted">The order you are looking for does not exist or could not be found.</p>
    </div>
</div>
}



<ng-template #warning let-modal let-user="user">

    <div class="modal-header d-flex justify-content-between align-items-center gap-2">
        <h4 class="modal-title">Reassign Rider</h4>
        <button type="button" aria-label="Close" class="ad-close-btn" (click)="modal.dismiss('Cross click')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    d="m7 7l10 10M7 17L17 7" stroke-width="1"></path>
            </svg>
        </button>
    </div>
    <div class="modal-body ad-reassign-confirm">
        <span class="ad-reassign-confirm__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
        </span>
        <p class="ad-reassign-confirm__title">Are you sure you want to reassign this order?</p>
        <p class="ad-reassign-confirm__text">The current rider will be released from this order.</p>
        <div class="ad-reassign-confirm__note">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>The order will remain in <strong>Pending</strong> status until a new rider is assigned.</span>
        </div>
    </div>
    <div class="modal-footer ad-reassign-confirm__actions">
        <button type="button" class="ad-reassign-confirm__btn is-cancel" ngbAutofocus (click)="modal.dismiss('Cancel')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12"></path>
            </svg>
            <span>No, keep rider</span>
        </button>
        <button type="button" class="ad-reassign-confirm__btn is-confirm" (click)="reassignOrder('yes')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M20 6 9 17l-5-5"></path>
            </svg>
            <span>Yes, reassign</span>
        </button>
    </div>
</ng-template>